import Image from "next/image";
import { useEffect, useState } from "react";
import { GoPlus } from "react-icons/go";
import { TbMinus } from "react-icons/tb";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

import { toCdnUrl } from "../../lib/cdn";
import { resolveImage } from "../../lib/media";
import Picture from "../Picture";

const BagItem = ({ item, removeProductFromCart, updateProductCount }) => {
  const [count, setCount] = useState(item.quantity || 1);
  const [availableStock, setAvailableStock] = useState(0);
  const [mounted, setMounted] = useState(false);
  const [isRemoving, setIsRemoving] = useState(false);

  const specLine = [...(item.customFields || []).map((ca) => String(ca.value)), item.size]
    .filter(Boolean)
    .join(" · ");

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    updateProductCount(item.id, item.size, count);
    if (item.size) {
      const option = findProductStockAndPrice(item.size, item);
      setAvailableStock(typeof option?.quantity === "number" ? option.quantity : 0);
    } else {
      setAvailableStock(typeof item.availableQuantity === "number" ? item.availableQuantity : 0);
    }
  }, [count]);

  useEffect(() => {
    if (mounted && item?.fields?.["Other photos"]?.length) {
      localStorage.clear();
      window.location.reload();
    }
  }, [mounted, item]);

  const findProductStockAndPrice = (size, product) => {
    if (!size) {
      size = "-";
    }
    return (product.options || []).find((option) => option.title === size);
  };

  const photos = item?.photos || [];
  const photo = photos[0];
  const originalPhoto = typeof photo === "string" ? photo : photo?.src;
  const photoV2 = typeof photo === "object" ? photo : null;
  const newPhoto = originalPhoto ? toCdnUrl(originalPhoto) : "";
  const fallBackPhoto = originalPhoto;
  const resolved = resolveImage(originalPhoto, photoV2, "cart");

  if (!mounted) {
    return null;
  }

  return (
    <div className="relative">
      <div
        className={`flex items-start gap-4 ${isRemoving ? "pointer-events-none opacity-60" : ""}`}
      >
        <div className="relative h-[70px] w-[70px] shrink-0 overflow-hidden rounded-lg border border-[#ECEFF1]">
          {resolved.isV2 ? (
            <Picture
              resolved={resolved}
              alt="Order name"
              width={70}
              height={70}
              imgClassName="h-full w-full object-cover"
            />
          ) : (
            <Image
              src={newPhoto}
              unoptimized={true}
              height={70}
              width={70}
              alt="Order name"
              className="h-full w-full object-cover"
              onError={(e) => {
                e.target.src = fallBackPhoto;
              }}
            />
          )}

          {item.colour ? (
            <div
              className="absolute right-[-1px] top-[-1px] z-[999] h-3 w-3 rounded-full"
              style={{ backgroundColor: item.colour }}
            ></div>
          ) : null}
        </div>

        <div className="min-w-0 flex-1">
          <div className="flex items-start gap-[27px]">
            <span className="min-w-0 flex-1 text-[14px] font-medium text-checkoutText">
              {item.title}
            </span>

            <span className="shrink-0 text-right text-[14px] font-medium text-checkoutText">
              {`${String.fromCharCode(0x20b9)}${count * item.salePrice}`}
            </span>
          </div>

          {specLine ? (
            <div className="mt-1 text-[12px] font-normal text-[#4B5563]">{specLine}</div>
          ) : null}

          <div className="mt-2 flex items-center gap-x-4 text-[14px] font-medium">
            <button
              type="button"
              onClick={() => {
                if (isRemoving) return;
                if (count < 2) {
                  setIsRemoving(true);
                  removeProductFromCart(item.id)();
                  return;
                }
                setCount(count - 1);
              }}
              aria-label="Decrement quantity"
            >
              <TbMinus size={16} />
            </button>

            <span>{count}</span>

            <button
              type="button"
              onClick={() => {
                if (isRemoving) return;
                if (count < availableStock) {
                  setCount(count + 1);
                }
              }}
              aria-label="Increment quantity"
            >
              <GoPlus size={16} />
            </button>
          </div>
        </div>
      </div>

      {isRemoving ? (
        <div className="absolute inset-0 z-10 flex items-center justify-center">
          <Loader type="Oval" color="#ccc" height={28} width={28} />
        </div>
      ) : null}
    </div>
  );
};

export default BagItem;
